module.exports = __webpack_public_path__ + "static/media/4-foto-tafel.bd8c7d81.jpg";